/**
 * Task cards open the vendor list for one trade.
 * Matching lives in src/shared/vendorTrades.js so AI chat uses the same map.
 */

import {
  TASK_CATEGORY_TRADES,
  UNMAPPED_TASK_CATEGORIES,
  tradeForTaskCategory,
  vendorMatchesTrade,
  vendorsMatchingTrade,
} from '../shared/vendorTrades';

export {
  TASK_CATEGORY_TRADES,
  UNMAPPED_TASK_CATEGORIES,
  tradeForTaskCategory,
  vendorMatchesTrade,
  vendorsMatchingTrade,
};

/**
 * Library maintenance tasks with a mapped trade get a Find a pro button.
 * Custom tasks, blank categories, financial deadlines, and unmapped
 * categories do not.
 */
export function findAProTrade(clientTask) {
  if (!clientTask || clientTask.task_id == null || clientTask.task_id === '') return null;
  const library = clientTask.task || {};
  const category = library.category || clientTask.category || '';
  return tradeForTaskCategory(category);
}

export function noTradeProsNote(trade) {
  return `No ${String(trade || '').toLowerCase()} vendors yet. Here are all of your sponsor's vendors.`;
}

/**
 * Project tasks keep an explicitly pinned vendor. Otherwise they use the
 * same exact trade map. Title words and a Handyman catch-all do not match.
 */
export function matchProjectTaskVendors(task, vendors) {
  const list = Array.isArray(vendors) ? vendors : [];
  const ids = Array.isArray(task && task.vendor_ids) ? task.vendor_ids.map((id) => String(id)) : [];
  if (ids.length) {
    return list.filter((vendor) => vendor && ids.includes(String(vendor.id)));
  }
  return vendorsMatchingTrade(list, tradeForTaskCategory(task && task.category));
}

export function findRelevantVendors(task, vendors) {
  return vendorsMatchingTrade(vendors, tradeForTaskCategory(task && task.category));
}
